import { css } from 'styled-components/macro'
import GoldenBg from 'assets/golden-bg.webp'

export const styleReset = css`
  appearance: none;
  padding: 0;
  margin: 0;
  border: none;
  font: inherit;
  text-align: inherit;
  color: inherit;
  background: none;
`

export const Overlay = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

export const Thread = css`
  content: '';
  display: block;
  position: absolute;
  mask-size: contain;
  background: url(${GoldenBg}) center center / cover no-repeat;
  z-index: -1;
`
